import { useProducts } from '../../hooks/useFirestore';

const ComingSoonProducts = () => {
  const { data: products, loading } = useProducts();
  const hasProducts = Array.isArray(products) && products.length > 0;

  return (
    <section className="section section-gray" id="products">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Coming Soon</span>
          <h2 className="section-title">Upcoming Offer Lifetime# Products</h2>
          <p className="section-description">
            We’re crafting brand-new products exclusively for our VIP community.
            Admins can add products anytime—until then enjoy this sneak peek.
          </p>
        </div>

        {loading ? (
          <div className="coming-soon-loading">Loading products...</div>
        ) : hasProducts ? (
          <div className="product-live-grid">
            {products.map((product) => (
              <div
                key={product.id}
                className={`product-card ${product.status === 'active' ? 'product-card-active' : ''}`}
              >
                <div className="product-card-header">
                  <div className="product-icon">
                    <i data-lucide="sparkles"></i>
                  </div>
                  <span className={`product-status ${product.status || 'coming_soon'}`}>
                    {product.status === 'active' ? 'Live' : 'Coming Soon'}
                  </span>
                </div>

                {product.imageUrl ? (
                  <div className="product-card-image">
                    <img src={product.imageUrl} alt={product.title || 'Upcoming product'} />
                  </div>
                ) : (
                  <div className="product-card-image placeholder">
                    <span className="material-symbols-outlined">photo</span>
                  </div>
                )}

                <h3 className="product-title">{product.title || 'Untitled Product'}</h3>
                <p className="product-description">{product.description || 'Details will be revealed soon.'}</p>

                {product.launchDate && (
                  <div className="product-launch">
                    <span>Launch Date</span>
                    <strong>{product.launchDate}</strong>
                  </div>
                )}

                {product.benefits && product.benefits.length > 0 && (
                  <ul className="product-benefits">
                    {product.benefits.map((benefit, benefitIndex) => (
                      <li key={benefitIndex}>
                        <i data-lucide="check-circle"></i>
                        <span>{benefit}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="coming-soon-panel">
            <h3>COMING SOON</h3>
            <p>Our product showcase is in the works. Check back soon for exclusive launches!</p>
            <span className="coming-soon-note-text">
              Admins can add products anytime from the Product Management page.
            </span>
          </div>
        )}
      </div>
    </section>
  );
};

export default ComingSoonProducts;
